<template>
    <el-form size="mini" :inline="true" :model="form">
        <el-form-item label="申请医生">
            <el-select v-model="form.region" placeholder="申请医生">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="状态">
            <el-select v-model="form.region" placeholder="状态">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="申请时间">
            <el-date-picker
                v-model="form.value6"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="handler">发起申请</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
  export default {
    name: "dignose-apply-form",
    props: {
      value: {
        type: Object,
        default: () => {
          return {}
        }
      },
    },
    data() {
      return {
        form: {}
      }
    },
    methods: {
      handler() {
        const {params} = this.$route;
        this.$router.push(`/main/diagnose/${params.type}/apply`);
      }
    },
  }
</script>

<style scoped>

</style>
